import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';

import { getApiDatas } from "../utilities/FrontFunctions/AoxFrontFunctions"

import ObjExpertiseBrand from './inc/ObjExpertiseBrand'
import ObjTableauBadgesExpertise from './inc/ObjTableauBadgesExpertise'
import ObjExpertiseBadge from './inc/ObjExpertiseBadge'

class PageMonExpertise extends Component {  //GIT Expertise
	constructor(props) {
		super(props)
		this.state = {
			apiDatas:[],
		}
	}

	componentDidMount() {
		getApiDatas(`/apiaox/Call/PageExpertise`).then((apiDatas) => { this.setState({ apiDatas:apiDatas }) })

		// add body class
		document.body.classList.add('pg_compte')    //!! ne s'applique pas si MainHeader sClassForPage
		window.scrollTo(0,0)
		// add and dispatch window resize
		window.addEventListener('resize', this.throttleWindowResizeSectionCompte)
		window.dispatchEvent(new Event('resize'))
  	}
  	componentWillUnmount() {
		// remove body class
		document.body.classList.remove('pg_compte')
		// remove window resize
		window.removeEventListener('resize', this.throttleWindowResizeSectionCompte)
	}
	render() {
		const apiDatas = this.state.apiDatas

        //bagdes non groupés
        const listBadgesNonGroupe = (apiDatas.Badges ?? []).filter(b => !b.Badge_GroupeCode);
        //filtrage des badges groupés
        const listBadgesGroupe = Object.values(
            (apiDatas.Badges ?? []).filter(b => b.Badge_GroupeCode)
            .reduce((acc, b) => {
                const code = b.Badge_GroupeCode;
                const userBadgeGroupe = apiDatas.Badges.filter(o => o.Badge_GroupeCode === code && apiDatas.UserBadges.find(ub => ub.UserBadge_Badge_Id === o.Badge_Id));
                //si aucun badge du groupe gagné, retenir le plus bas
                if(userBadgeGroupe.length === 0){
                    if (!acc[code] || b.Badge_GroupeLevel < acc[code].Badge_GroupeLevel) {
                        acc[code] = b;
                    }
                } else if (userBadgeGroupe.find(o => o.Badge_Id === b.Badge_Id)) {
                    //si badge du groupe gagné par l'user, on garde le plus haut gagné
                    if (!acc[code] || b.Badge_GroupeLevel > acc[code].Badge_GroupeLevel) {
                        acc[code] = b;
                    }
                }
                return acc;
            }, {})
        );
        const listBadges = [...listBadgesNonGroupe, ...listBadgesGroupe].sort((a, b) => a.Badge_Id - b.Badge_Id);

		return (<>{ apiDatas && <>
			<section className="obj_section section_expertise">
				<div className="ctn_section">
					<div className="ctn_title">
						<h2 className="t_title">Mon expertise</h2>
					</div>

					{apiDatas.UserSiteExpertise && (<>
						<div className="obj_bloc_expertise var_global is-expanded">
							<button className="obj_header_exp">
								<h3 className="t_title">Mon Expertise globale</h3>
							</button>

							<div className='ctn_content'>
								<div className='ctn_row'>

									<div className="obj_recompences_exp">
										
										<h3 className="t_title"><strong>Mes badges</strong></h3>

										<div className="lst_items_exp">
                                            {listBadges?.filter(o => o.Badge_Brand_Id==null).map((badge, index) => (
                                                <ObjExpertiseBadge
                                                    key={index}
                                                    badge={badge}
                                                    userBadge={apiDatas.UserBadges.find(o => (o.UserBadge_Badge_Id === badge.Badge_Id))}
                                                />
                                            ))}
										</div>
									</div>

								</div>
							</div>
						</div>
                        
                        {apiDatas.UserBrandExpertise.map( (userBrand,index) => 
                            <ObjExpertiseBrand 
                                key={index}
                                user={userBrand}
                                badges={apiDatas.Badges.filter(o => o.Badge_Brand_Id===userBrand.Brand_Id)}
                                userBadges={apiDatas.UserBadges}
                            />
                        )}
					</>)}
				</div>
			</section>

			<section className="obj_section obj_section section_tableau_recompenses">
				<div className="ctn_section">
					<div className="ctn_title">
						<h2 className="t_subtitle"><strong>Tableau des <br />Récompenses</strong></h2>
					</div>
					{apiDatas.BadgesCategories &&
						<div className="obj_tableau_recompences_exp">
							<ObjTableauBadgesExpertise 
								categories={apiDatas.BadgesCategories} 
								badges={listBadges.filter(o => o.Badge_Brand_Id==null || apiDatas.UserBrandExpertise.find(brand => brand.Brand_Id === o.Badge_Brand_Id))}
								userBadges={apiDatas.UserBadges}/>
						</div>
					}
				</div>
			</section>
		</>}</>)
	}
}

export default withTranslation()(PageMonExpertise)